import { devLog } from './logger';
let audioCtx = null;

function getContext() {
  if (!audioCtx || audioCtx.state === 'closed') {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

export function playSound(type) {
  try {
    const ctx = getContext();
    if (ctx.state === 'suspended') ctx.resume();

    const beep = (freq, duration, delay = 0) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.25, ctx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + duration);
      osc.start(ctx.currentTime + delay);
      osc.stop(ctx.currentTime + delay + duration + 0.01);
    };

    switch (type) {
      case 'new_order':
        beep(880, 0.12);
        beep(1100, 0.18, 0.15);
        break;
      case 'order_ready':
        beep(1047, 0.1);
        beep(1319, 0.1, 0.12);
        beep(1568, 0.2, 0.24);
        break;
      case 'warning':
        beep(440, 0.25);
        beep(330, 0.3, 0.3);
        break;
      case 'offline_queued':
        beep(300, 0.15);
        beep(250, 0.15, 0.2);
        break;
      case 'sync_complete':
        beep(660, 0.1);
        beep(880, 0.1, 0.12);
        beep(1100, 0.15, 0.24);
        break;
      default:
        beep(800, 0.1);
        break;
    }
  } catch (e) {
    devLog.warn('Sound playback failed:', e);
  }
}

